import { useState, useEffect, useRef, useCallback } from 'react';
import { toJS } from 'mobx';
import useStore from '../../hooks/useStore';

const SPORT_BANNER_VERSION = '2'; // This version is used to invalidate localStorage data when the code changes
const TRANSITION_INTERVAL = 10000; // 6s -> 4s -> 10s NOS-878
const videoExtensions = ['.mp4', '.webm', '.ogg', '.mov', '.avi', '.mkv'];

export const getMatchInfoFromUrl = () => {
  const pathParts = window.location.pathname.split('/');

  // Example pathParts: ["", "match", "soccer", "11538434", "cheer"]
  const sportsType = pathParts[2]; // "soccer"
  const matchId = pathParts[3]; // "11538434"

  return { sportsType, matchId };
};


const getRandomIndex = (remainingIndexes, totalBanners) => {
  if (remainingIndexes.length === 0) {
    return Array.from({ length: totalBanners }, (_, i) => i);
  }
  return remainingIndexes;
};

// const getNextRandomIndex = (remainingIndexes, setRemainingIndexes, totalBanners) => {
//   const updatedIndexes = getRandomIndex(remainingIndexes, totalBanners);
//   const randomIdx = Math.floor(Math.random() * updatedIndexes.length);
//   const nextIndex = updatedIndexes[randomIdx];
//   setRemainingIndexes(updatedIndexes.filter((_, i) => i !== randomIdx));
//   return nextIndex;
// };

const getNextRandomItem = (remainingItems, setRemainingItems) => {
  if (!remainingItems || remainingItems.length === 0) return null;

  const randomIdx = Math.floor(Math.random() * remainingItems.length);
  const nextItem = remainingItems[randomIdx];

  const updated = [...remainingItems];
  updated.splice(randomIdx, 1); // remove selected item
  setRemainingItems(updated);

  return nextItem;
};

export const useBannerSportCheer = () => {
  const [leftBannerIndex, setLeftBannerIndex] = useState(0);
  const [rightBannerIndex, setRightBannerIndex] = useState(0);
  const [sportsBannerLeft, setSportsBannerLeft] = useState([]);
  const [sportsBannerRight, setSportsBannerRight] = useState([]);
  const [leftBannerStartTime, setLeftBannerStartTime] = useState(Date.now());
  const [rightBannerStartTime, setRightBannerStartTime] = useState(Date.now());
  const [leftVideoDuration, setLeftVideoDuration] = useState(0);
  const [rightVideoDuration, setRightVideoDuration] = useState(0);

  const leftVideoPlayCountRef = useRef(0);
  const rightVideoPlayCountRef = useRef(0);
  const leftLastPlayedRef = useRef(0);
  const rightLastPlayedRef = useRef(0);
  const [remainingLeftIndexes, setRemainingLeftIndexes] = useState([]);
  const [remainingRightIndexes, setRemainingRightIndexes] = useState([]);

  const [fetchingBanner, setFetchingBanner] = useState(true);

  const { bannerStore } = useStore();

  useEffect(() => {
    setFetchingBanner(true);
    bannerStore
      .getList()
      .then(() => {})
      .finally(() => {
        setFetchingBanner(false);
      });
  }, []);

  useEffect(() => {
    setSportsBannerLeft(toJS(bannerStore.sportsMobileBannerLeft) || []);
    setSportsBannerRight(toJS(bannerStore.sportsMobileBannerRight) || []);

    const { sportsType, matchId } = getMatchInfoFromUrl();

    // if (bannerStore.sportsMobileBannerLeft.length > 0) {
    //   const storedLeft = localStorage.getItem('remaining_indexes_left_mobile_'+sportsType+'_'+matchId);
    //   const parsedLeft = storedLeft ? JSON.parse(storedLeft) : [];
    //
    //   let sportsBannerLeftArr = parsedLeft.length > 0 ? parsedLeft : toJS(bannerStore.sportsMobileBannerLeft);
    //   let randomIdxLeft = getNextRandomIndex(remainingLeftIndexes, setRemainingLeftIndexes, sportsBannerLeftArr.length);
    //   let currentLeft = sportsBannerLeftArr.filter((_, i) => i === randomIdxLeft);
    //   if (currentLeft.length === 0) {
    //     debugger;
    //   }
    //   setSportsBannerLeft(currentLeft);
    //
    //   let remainingLeft = sportsBannerLeftArr.filter((_, i) => i !== randomIdxLeft);
    //   localStorage.setItem('remaining_indexes_left_mobile_'+sportsType+'_'+matchId, JSON.stringify(remainingLeft));
    // }

    //Check if the current version is different from the stored version
    // If different, remove the localStorage items
    const currentVersion = localStorage.getItem('sports_banner_version');
    if (currentVersion !== SPORT_BANNER_VERSION) {
      const prefixLeft = 'remaining_items_left_mobile_';
      const prefixRight = 'remaining_items_right_mobile_';
      for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (key.startsWith(prefixLeft) || key.startsWith(prefixRight)) {
          localStorage.removeItem(key);
          // Decrement i to account for the change in localStorage length
          i--;
        }
      }

      localStorage.setItem('sports_banner_version', SPORT_BANNER_VERSION);
    }

    if (bannerStore.sportsMobileBannerLeft.length > 0) {
      const storedLeft = localStorage.getItem('remaining_items_left_mobile_' + sportsType + '_' + matchId);
      const parsedLeft = storedLeft ? JSON.parse(storedLeft) : [];

      const fallbackLeft = toJS(bannerStore.sportsMobileBannerLeft);
      const bannerLeftPool = parsedLeft.length > 0 ? parsedLeft : fallbackLeft;

      const randomLeftItem = getNextRandomItem(bannerLeftPool, setRemainingLeftIndexes);
      if (randomLeftItem) {
        setSportsBannerLeft([randomLeftItem]);
        const remaining = bannerLeftPool.filter((item) => item !== randomLeftItem);
        localStorage.setItem('remaining_items_left_mobile_' + sportsType + '_' + matchId, JSON.stringify(remaining));
      } else {
        setSportsBannerLeft([]);
      }
    }


    // if (bannerStore.sportsMobileBannerRight.length > 0) {
    //   const storedRight = localStorage.getItem('remaining_indexes_right_mobile_'+sportsType+'_'+matchId);
    //   const parsedRight = storedRight ? JSON.parse(storedRight) : [];
    //
    //   let sportsBannerRightArr = parsedRight.length > 0 ? parsedRight : toJS(bannerStore.sportsMobileBannerRight);
    //   let randomIdxRight = getNextRandomIndex(remainingRightIndexes, setRemainingRightIndexes, sportsBannerRightArr.length);
    //   let currentRight = sportsBannerRightArr.filter((_, i) => i === randomIdxRight);
    //   setSportsBannerRight(currentRight);
    //
    //   let remainingRight = sportsBannerRightArr.filter((_, i) => i !== randomIdxRight);
    //   localStorage.setItem('remaining_indexes_right_mobile_'+sportsType+'_'+matchId, JSON.stringify(remainingRight));
    // }
    if (bannerStore.sportsMobileBannerRight.length > 0) {
      const storedRight = localStorage.getItem('remaining_items_right_mobile_' + sportsType + '_' + matchId);
      const parsedRight = storedRight ? JSON.parse(storedRight) : [];

      const fallbackRight = toJS(bannerStore.sportsMobileBannerRight);
      const bannerRightPool = parsedRight.length > 0 ? parsedRight : fallbackRight;

      const randomRightItem = getNextRandomItem(bannerRightPool, setRemainingRightIndexes);
      if (randomRightItem) {
        setSportsBannerRight([randomRightItem]);
        const remaining = bannerRightPool.filter((item) => item !== randomRightItem);
        localStorage.setItem('remaining_items_right_mobile_' + sportsType + '_' + matchId, JSON.stringify(remaining));
      } else {
        setSportsBannerRight([]);
      }
    }


  }, [bannerStore.sportsMobileBannerLeft, bannerStore.sportsMobileBannerRight, bannerStore.isBannerLoaded]);

  // Banner transition effects
  useEffect(() => {
    leftVideoPlayCountRef.current = 0;
    setLeftBannerStartTime(Date.now());
  }, [leftBannerIndex]);

  useEffect(() => {
    rightVideoPlayCountRef.current = 0;
    setRightBannerStartTime(Date.now());
  }, [rightBannerIndex]);

  // Interval for banner transitions
  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     const currentTime = Date.now();
  //
  //     if (sportsBannerLeft.length > 1) {
  //       const leftBanner = sportsBannerLeft[leftBannerIndex];
  //       const leftElapsedTime = (currentTime - leftBannerStartTime) / 1000;
  //
  //       if (isVideoUrl(leftBanner?.imgPath)) {
  //         const minLoopsNeeded = Math.ceil(TRANSITION_INTERVAL / (leftVideoDuration * 1000));
  //         if (leftElapsedTime >= TRANSITION_INTERVAL / 1000 && leftVideoPlayCountRef.current >= minLoopsNeeded) {
  //           setLeftBannerIndex((prev) => (prev + 1) % sportsBannerLeft.length);
  //         }
  //       } else if (leftElapsedTime >= TRANSITION_INTERVAL / 1000) {
  //         setLeftBannerIndex((prev) => (prev + 1) % sportsBannerLeft.length);
  //       }
  //     }
  //
  //     if (sportsBannerRight.length > 1) {
  //       const rightBanner = sportsBannerRight[rightBannerIndex];
  //       const rightElapsedTime = (currentTime - rightBannerStartTime) / 1000;
  //
  //       if (isVideoUrl(rightBanner?.imgPath)) {
  //         const minLoopsNeeded = Math.ceil(TRANSITION_INTERVAL / (rightVideoDuration * 1000));
  //         if (rightElapsedTime >= TRANSITION_INTERVAL / 1000 && rightVideoPlayCountRef.current >= minLoopsNeeded) {
  //           setRightBannerIndex((prev) => (prev + 1) % sportsBannerRight.length);
  //         }
  //       } else if (rightElapsedTime >= TRANSITION_INTERVAL / 1000) {
  //         setRightBannerIndex((prev) => (prev + 1) % sportsBannerRight.length);
  //       }
  //     }
  //   }, 500);
  //
  //   return () => clearInterval(interval);
  // }, [
  //   leftBannerIndex,
  //   rightBannerIndex,
  //   leftBannerStartTime,
  //   rightBannerStartTime,
  //   leftVideoDuration,
  //   rightVideoDuration,
  //   sportsBannerLeft,
  //   sportsBannerRight,
  // ]);

  const handleVideoProgress = useCallback((played, isLeft) => {
    if (isLeft) {
      if (played < leftLastPlayedRef.current) {
        leftVideoPlayCountRef.current += 1;
      }
      leftLastPlayedRef.current = played;
    } else {
      if (played < rightLastPlayedRef.current) {
        rightVideoPlayCountRef.current += 1;
      }
      rightLastPlayedRef.current = played;
    }
  }, []);

  const handleVideoDuration = useCallback((duration, isLeft) => {
    if (isLeft) {
      setLeftVideoDuration(duration);
    } else {
      setRightVideoDuration(duration);
    }
  }, []);

  return {
    fetchingBanner,
    leftBannerIndex,
    rightBannerIndex,
    currentLeftBanner: sportsBannerLeft[leftBannerIndex],
    currentRightBanner: sportsBannerRight[rightBannerIndex],
    handleVideoProgress,
    handleVideoDuration,
  };
};

// Utility functions
export const isVideoUrl = (url) => {
  return videoExtensions.some((ext) => url?.toLowerCase().endsWith(ext));
};

export const isIOS = () => /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

export const isAndroid = () => {
  return /Android/.test(navigator.userAgent) || /Linux/.test(navigator.platform);
};

export const isValidUrl = (string) => {
  try {
    new URL(string);
    return true;
  } catch (_) {
    return false;
  }
};

export const getContactUsHref = () => {
  let contactUsHref;
  switch (window.location.hostname) {
    case 'm.named.com':
      contactUsHref = 'https://sports.named.com/contact-us';
      break;
    case 'm.nmd.co':
      contactUsHref = 'https://sports.nmd.co/contact-us';
      break;
    case 'm-stage.named.com':
      contactUsHref = 'https://stage-sports.named.com/contact-us';
      break;
    case 'm-stage.nmd.co':
      contactUsHref = 'https://stage-sports.nmd.co/contact-us';
      break;
    case 'dev-m.named.com':
      contactUsHref = 'http://dev-sports.named.com/contact-us';
      break;
    case 'dev-m.nmd.co':
      contactUsHref = 'http://dev-sports.nmd.co/contact-us';
      break;
    case 'localhost':
      contactUsHref = `http://${window.location.host}/contact-us`;
      break;
    default:
      contactUsHref = 'https://sports.named.com/contact-us';
      break;
  }

  return contactUsHref;
};
